import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IContactDetailsResponse } from "@miplatform/types";

export const useContacts = () => {
  const [contacts, setContacts] = useState<IContactDetailsResponse[]>([]);

  const stateManager = useComponentState();

  const getContacts = ({
    filters,
    sort,
    params,
    signal,
    top,
    skip,
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await accountService.contacts.getAll({
        filters,
        sort,
        params,
        signal,
        top,
        skip,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setContacts(response.data);
      }
      return response;
    });
  };

  return {
    contacts,
    setContacts,
    getContacts,
  };
};
